module.exports = __webpack_public_path__ + "static/media/MuleSoft-logo.ef5d97c8.png";